import React from 'react';
import { PlanSection } from './PlanSection';
import { formatAsstTime } from './PlanQueue.utils';
import { ProcessedCartData } from './PlanQueue.types';
import { MinimalItem } from 'src/pages/AssortmentBuild/Planning.types';
import styles from './PlanQueue.styles';

interface CartPlanTabProps {
  hasError: boolean;
  /** The data count, passed in to not 'reprocess' the data for counting */
  count: number;
  data: ProcessedCartData;
  search: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function CartPlanQueueError() {
  return (
    <div className={styles.errorContainer}>
      <span className={styles.errorMessage}>⚠️ Cannot Fetch Add to Assortment Status</span>
    </div>
  );
}

function AsstTime(item: MinimalItem | undefined) {
  return <span>{formatAsstTime(item?.updatedAt ?? '')}</span>;
}

export const CartPlanTab = ({ hasError, data }: CartPlanTabProps) => {
  const { processing, failed } = data;
  return hasError ? (
    <CartPlanQueueError />
  ) : (
    <div>
      <div className={styles.searchContainer}>
        {/* <input type="text" placeholder="Search item by description" value={search} onChange={onSearchChange} /> */}
      </div>
      <section className={styles.itemsContainer}>
        <PlanSection
          items={processing.items}
          sectionName={'Processing'}
          componentType={{ component: 'span' }}
          badgeColor={processing.badgeColor}
        />
        <PlanSection
          items={failed.items}
          sectionName={'Failed'}
          componentType={{ variant: 'caption' }}
          secondaryList={AsstTime}
          badgeColor={failed.badgeColor}
        />
      </section>
    </div>
  );
};
